import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable} from "mobx";
import {Bindings} from "data/constants/bindings";
import type {IUserStore} from "data/stores/user/user.store";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {ITeamStore} from "data/stores/team/team.store";
import {TeamRegion} from "data/enums";
import {fill, size} from "lodash";

export interface ILandingController extends ViewController {
	get i18n(): ILocalizationStore;
	get isSelectedStart(): boolean;
	get isTeamSavedAfterLogin(): boolean;

	setSelectedRegion: (value: TeamRegion) => void;
	clearSelectedStarted: () => void;
}

@injectable()
export class LandingController implements ILandingController {
	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.TeamStore) private _teamStore: ITeamStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get isSelectedStart() {
		return this._teamStore.isSelectedStart;
	}

	get isTeamSavedAfterLogin() {
		return this._teamStore.isTeamSavedAfterLogin;
	}

	setSelectedRegion = (value: TeamRegion) => {
		this._teamStore.setFirstSelectedRegion(value);
		this._teamStore.setSelectedRegion(value);
	};

	clearSelectedStarted = () => {
		this._teamStore.clearIsSelectedStart();
	};

	dispose() {
		return;
	}

	init(param: void) {
		this._teamStore.clearIsSelectedStart();
		if (!this._teamStore.isSelectTeamCompleted && !this._teamStore.isTeamSavedAfterLogin) {
			this._teamStore.setLineup(TeamRegion.Usa, fill(Array(12), 0));
			this._teamStore.setLineup(TeamRegion.Europe, fill(Array(12), 0));
			this._teamStore.toFirstStep();
		}

		const euLineup = JSON.parse(localStorage.getItem("euLineup") || "[]") as number[];
		const usLineup = JSON.parse(localStorage.getItem("usLineup") || "[]") as number[];

		if ([size(euLineup), size(usLineup)].every(Boolean)) {
			this._teamStore.setIsSelectedStart();
		}
	}
}
